import React, { useState } from "react"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"

const ProvinceOutDetailModal = ({ data, open, setOpen }) => {
  return (
    <Modal
      isOpen={open}
      role="dialog"
      autoFocus={true}
      centered={true}
      tabIndex="-1"
      toggle={() => {
        setOpen(!open)
      }}
      size="xl"
    >
      <div>
        <ModalHeader
          toggle={() => {
            setOpen(!open)
          }}
        >
          Summary
        </ModalHeader>
        <ModalBody>
          <div className="table-responsive">
            <div
              style={{
                borderBottom: "0.8px solid #9facc2",
                padding: 20,
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <Row>
                <Col lg={12}>
                  <div>
                    <h6 className="detailTitle">Out Quantity</h6>
                    <p className="detailValue">{data?.out_quantity} </p>
                  </div>
                </Col>
              </Row>
            </div>
            <Row
              style={{
                justifyContent: "center",
                textAlign: "center",
                marginTop: 20,
              }}
            >
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Provider</h6>
                  <p className="detailValue">{data?.provider?.title}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Item Category</h6>
                  <p className="detailValue">{data?.item_category?.name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Item</h6>
                  <p className="detailValue">{data?.item?.item_name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Province</h6>
                  <p className="detailValue">{data?.province?.province}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Facility</h6>
                  <p className="detailValue">
                    {data?.facility?.facility_name &&
                      data?.facility?.facility_name != "Others" &&
                      data?.facility?.facility_name}
                  </p>
                  <p className="detailValue">{data?.distributor}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">UNFPA ITEM ID</h6>
                  <p className="detailValue">{data?.item?.unfp_item_name}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">IP- ITEM DESCRIPTION</h6>
                  <p className="detailValue">
                    {data?.item?.ip_item_description}
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">UNFPA UOM</h6>
                  <p className="detailValue">
                    {data?.item?.uom}{" "}
                    {data?.item?.unfpa_uom_quantity > 1 &&
                      data?.item?.unfpa_uom_quantity}
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">IP UOM</h6>
                  <p className="detailValue">
                    {data?.item?.ip_unit_umo}{" "}
                    {data?.item?.ip_uom_quantity > 1 &&
                      data?.item?.ip_uom_quantity}
                  </p>
                </div>
              </Col>

              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Batch / lot number</h6>
                  <p className="detailValue">
                    {data?.province_in?.batch_number}
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Expiry / best before date</h6>
                  <p className="detailValue">
                    {data?.province_in?.expire_date}
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div>
                  <h6 className="detailTitle">Distribution Date</h6>
                  <p className="detailValue">{data?.date}</p>
                </div>
              </Col>
            </Row>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

export default ProvinceOutDetailModal
